"use client";

import { cn } from "@/utils/utils";
import { usePathname } from "next/navigation";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

import LinkElement from "@/components/LinkElement";

const translate = {
  my_account: "my_account",
  address_mine: "address_mine",
  my_order: "my_order",
  my_coupon: "my_coupon",
  membership: "membership",
};

function SidebarAcount() {
  const pathname = usePathname();

  const { t } = useTranslationApi(Object.values(translate));

  //
  const sidebars = [
    {
      link: "/account",
      label: t(translate.my_account),
    },
    {
      link: "/account/addresses",
      label: t(translate.address_mine),
    },
    {
      link: "/account/orders",
      label: t(translate.my_order),
    },
    // {
    //   link: "/account/mycoupon",
    //   label: t(translate.my_coupon),
    // },
    // {
    //   link: "/account/membership",
    //   label: t(translate.membership),
    // },
  ];
  //
  return (
    <ul>
      {sidebars.map((item) => {
        return (
          <li className="  text-base my-1 leading-6 " key={item.link}>
            <LinkElement
              className={cn(
                " text-gray-400 underline hover:font-bold hover:text-black",
                {
                  " no-underline text-black font-bold ": pathname === item.link,
                }
              )}
              href={item.link}
            >
              {item.label}
            </LinkElement>
          </li>
        );
      })}
    </ul>
  );
}

export default SidebarAcount;
